import { useRestaurantContext } from 'webReservations/context/RestaurantContext';
import { useQuery } from '@tanstack/react-query';
import { useParams, useSearchParams } from 'react-router-dom';
import {
  getRestaurantEventById,
  getRestaurantEventPricing,
} from './apiHelpers';
import {
  GUEST_COUNT_SEARCH_PARAM,
  RESTAURANT_EVENT_TIER_ID,
  SELECTED_ADD_ONS,
  SELECTED_FLOOR_PLAN_TABLE_ID,
} from './constants';
import type { SelectedAddOn } from './apiHelpers';

export const useRestaurantEvent = () => {
  const { restaurantDetails: restaurant } = useRestaurantContext();
  const { eventId } = useParams();

  return useQuery({
    queryKey: ['restaurantEvent', eventId],
    queryFn: async () =>
      getRestaurantEventById(restaurant.id, eventId as string),
    enabled: Boolean(eventId) && Boolean(restaurant.id),
  });
};

export const useRestaurantEventPricing = () => {
  const { restaurantDetails: restaurant } = useRestaurantContext();
  const { eventId } = useParams();
  const [searchParams] = useSearchParams();

  const guestCount = Number(searchParams.get(GUEST_COUNT_SEARCH_PARAM));
  const restaurantEventTierId = searchParams.get(RESTAURANT_EVENT_TIER_ID);
  const selectedFloorPlanTableId = searchParams.get(
    SELECTED_FLOOR_PLAN_TABLE_ID,
  );
  const selectedAddOnsParam = searchParams.get(SELECTED_ADD_ONS);
  const selectedAddOns: SelectedAddOn[] | undefined = selectedAddOnsParam
    ? JSON.parse(selectedAddOnsParam)
    : undefined;

  return useQuery({
    queryKey: [
      'restaurantEvent',
      eventId,
      'pricing',
      restaurantEventTierId,
      selectedAddOnsParam,
    ],
    queryFn: async () =>
      getRestaurantEventPricing({
        restaurantId: restaurant.id,
        eventId: eventId as string,
        guestCount,
        restaurantEventTierId: restaurantEventTierId as string,
        selectedFloorPlanTableId,
        selectedAddOns,
      }),
    enabled:
      Boolean(eventId) &&
      Boolean(restaurant.id) &&
      Boolean(restaurantEventTierId),
  });
};
